import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { Col, Row } from 'react-bootstrap';
import BackLink from '../../../../components/common/back-link';
import AdminSubmissionForm from '../../../../components/admin/submissions/form/submission-form';
import { destandard } from '../../../../utils/commonFunctions';
import { getSubmission, updateSubmission, validateSubmission, declineSubmission } from '../../../../actions/submissions';
import PageTitle from '../../../../components/common/page-title/index';

const model = 'deep.admin_submission';

class AdminSubmissionFormPage extends Component {
  constructor(props) {
    super(props);

    this.id = this.props.match.params.id;
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getSubmission(this.id))
      .then(() => {
        const { submission } = this.props;
        const data = destandard({
          ...submission.attributes
        });

        dispatch(actions.load(model, data));
      });
  }

  handleValidate = () => {
    const { dispatch } = this.props;
    const payload = {
      ...this.props.formData
    };

    dispatch(actions.submitFields(model, validateSubmission(this.id, payload, dispatch)));
  };

  handleDecline = () => {
    const { dispatch } = this.props;
    const payload = {
      ...this.props.formData
    };

    dispatch(actions.submitFields(model, declineSubmission(this.id, payload, dispatch)));
  };

  handleSubmit = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(model, updateSubmission(this.id, payload, dispatch)));
  };

  backLink = () => {
    const { isTeamRoute, isAuditRoute } = this.props;
    if (isAuditRoute) return '/admin/audit/submissions';
    const path = isTeamRoute ? 'team' : 'admin';

    return `/${path}/submissions`;
  }

  isEditable = () => {
    const { submission: { attributes } } = this.props;

    if (attributes) {
      if (attributes.status === 'DECLINED') {
        return true;
      }

      return !attributes['audit-completed'];
    }

    return true;
  }

  showMessage = () => {
    const { errors } = this.props;

    if (errors && errors.length > 0) {
      return errors[0];
    }

    return 'Loading...';
  }

  render() {
    const {
      loading, meta, isAuditRoute, submission
    } = this.props;
    const editable = isAuditRoute ? submission.attributes && submission.attributes.auditable : this.isEditable();
    let titleAction;
    if (editable) {
      titleAction = isAuditRoute ? 'Audit' : 'Edit';
    } else {
      titleAction = 'View';
    }
    return (
      <div className="container-fluid">
        <Row>
          <Col lg={12}>
            <BackLink href={this.backLink()} />
          </Col>
        </Row>
        <PageTitle>{titleAction} Submission</PageTitle>
        {loading ? this.showMessage() :
          (<AdminSubmissionForm
            onSubmit={this.handleSubmit.bind(this)}
            onValidate={this.handleValidate.bind(this)}
            onDecline={this.handleDecline.bind(this)}
            model={model}
            meta={meta}
            submissionId={this.id}
            editable={editable}
            isAudit={isAuditRoute}
            target={submission.attributes ? submission.attributes.target : null}
            id={submission.attributes ? submission.id : null}
          />
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  submission: state.submissions.submission,
  loading: !state.submissions.fetched && state.submissions.fetching,
  errors: state.submissions.errors,
  meta: state.submissions.meta,
  formData: state.deep.admin_submission,
  isTeamRoute: state.router.location.pathname.includes('team'),
  isAuditRoute: state.router.location.pathname.includes('audit')
});

export default connect(mapStateToProps)(AdminSubmissionFormPage);



// WEBPACK FOOTER //
// ./src/components/admin/submissions/form/submission-form-page.jsx